import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=bff2d2f8&scoped=true&"
import script from "./payment.vue?vue&type=script&lang=ts&"
export * from "./payment.vue?vue&type=script&lang=ts&"
import style0 from "./payment.vue?vue&type=style&index=0&id=bff2d2f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff2d2f8",
  null
  
)

export default component.exports